import {
  apiRequest,
} from './client'


export interface LoginRequest {
  email: string
  password: string
}


export interface LoginResponse {
  success: boolean
  message?: string
}


export interface RegisterRequest {
  name: string
  email: string
  password: string
  confirm_password: string
  invite_code?: string
  agree: boolean
  agree_offer: boolean
  email_marketing_consent: boolean
}


export interface RegisterResponse {
  success: boolean
  message: string
  requires_confirmation: boolean
}


export interface ConfirmRegistrationResponse {
  success: boolean
  state: string
  message: string
  user_name: string | null
  total_confirmed: number | null
}


export interface LogoutResponse {
  success: boolean
}


export interface PasswordResetRequest {
  email: string
}


export interface PasswordResetRequestResponse {
  success: boolean
  message: string
}


export interface PasswordResetVerifyResponse {
  success: boolean
  valid: boolean
  message: string
}


export interface PasswordResetConfirmRequest {
  token: string
  password: string
  confirm_password: string
}


export interface PasswordResetConfirmResponse {
  success: boolean
  message: string
}


export async function login(
  credentials: LoginRequest,
): Promise<LoginResponse> {
  return apiRequest<LoginResponse>(
    '/api/v1/auth/login',
    {
      method: 'POST',
      body: JSON.stringify(credentials),
    },
  )
}


export async function register(
  payload: RegisterRequest,
): Promise<RegisterResponse> {
  return apiRequest<RegisterResponse>(
    '/api/v1/auth/register',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  )
}


export async function confirmRegistration(
  code: string,
): Promise<ConfirmRegistrationResponse> {
  const params =
    new URLSearchParams({
      code,
    })

  return apiRequest<ConfirmRegistrationResponse>(
    `/api/v1/auth/confirm?${params.toString()}`,
    {
      method: 'GET',
    },
  )
}


export async function logout(): Promise<LogoutResponse> {
  return apiRequest<LogoutResponse>(
    '/api/v1/auth/logout',
    {
      method: 'POST',
    },
  )
}


export async function requestPasswordReset(
  payload: PasswordResetRequest,
): Promise<PasswordResetRequestResponse> {
  return apiRequest<PasswordResetRequestResponse>(
    '/api/v1/auth/password-reset/request',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  )
}


export async function verifyPasswordResetToken(
  token: string,
): Promise<PasswordResetVerifyResponse> {
  const params =
    new URLSearchParams({
      token,
    })

  return apiRequest<PasswordResetVerifyResponse>(
    `/api/v1/auth/password-reset/verify?${params.toString()}`,
    {
      method: 'GET',
    },
  )
}


export async function confirmPasswordReset(
  payload: PasswordResetConfirmRequest,
): Promise<PasswordResetConfirmResponse> {
  return apiRequest<PasswordResetConfirmResponse>(
    '/api/v1/auth/password-reset/confirm',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  )
}
